var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass:
        "avatar-da-conversa az-card-bordered d-flex align-center az-gap pa-4",
      attrs: { "aria-label": _vm.copy.ARIA, "data-test": "avatar-da-conversa" }
    },
    [
      _vm.temAoVivo
        ? _c("video", {
            ref: "video",
            staticClass: "avatar-da-conversa__ao-vivo",
            class: { "avatar-da-conversa__ao-vivo--falando": _vm.falando },
            attrs: {
              autoplay: "",
              muted: "",
              playsinline: "",
              "data-test": "avatar-da-conversa-ao-vivo"
            },
            domProps: { muted: true }
          })
        : _vm.temClipe
        ? _c("video", {
            staticClass: "avatar-da-conversa__midia",
            class: { "avatar-da-conversa__midia--falando": _vm.falando },
            attrs: {
              src: _vm.clipeEfetivo,
              autoplay: "",
              muted: "",
              loop: "",
              playsinline: "",
              "data-test": "avatar-da-conversa-clipe"
            },
            domProps: { muted: true }
          })
        : _vm.temRetrato
        ? _c("img", {
            staticClass: "avatar-da-conversa__midia",
            class: { "avatar-da-conversa__midia--falando": _vm.falando },
            attrs: {
              src: _vm.retrato,
              alt: _vm.copy.ARIA_RETRATO,
              "data-test": "avatar-da-conversa-retrato"
            }
          })
        : _c(
            "span",
            {
              staticClass:
                "avatar-da-conversa__midia avatar-da-conversa__selo d-flex align-center justify-center",
              class: { "avatar-da-conversa__midia--falando": _vm.falando },
              attrs: { "data-test": "avatar-da-conversa-selo" }
            },
            [
              _c("icon-svg", {
                attrs: { name: "ai-sparkle", size: 20, color: "var(--primary)" }
              })
            ],
            1
          ),
      _c(
        "p",
        {
          staticClass:
            "avatar-da-conversa__estado az-text-primary az-size-14 mb-0",
          attrs: {
            role: "status",
            "data-falando": _vm.falando ? "true" : "false",
            "data-test": "avatar-da-conversa-estado"
          }
        },
        [_vm._v(" " + _vm._s(_vm.rotuloDoEstado) + " ")]
      ),
      _c(
        "BaseButton",
        {
          staticClass: "ml-auto",
          attrs: {
            underlined: "",
            "fit-content": "",
            "data-test": "avatar-da-conversa-encerrar"
          },
          on: {
            click: function($event) {
              return _vm.$emit("encerrar")
            }
          }
        },
        [_vm._v(" " + _vm._s(_vm.copy.ENCERRAR) + " ")]
      ),
      _vm.temAoVivo
        ? _c("audio", {
            ref: "audio",
            attrs: { autoplay: "", "data-test": "avatar-da-conversa-audio" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }